import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

const labelVariants = cva(
  'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  {
    variants: {
      variant: {
        default: 'text-label-light dark:text-label-dark',
        error: 'text-red-500 dark:text-red-400',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof labelVariants> {}

export const Label = (
  {
    ref,
    className,
    variant,
    ...props
  }: LabelProps & {
    ref?: React.RefObject<HTMLLabelElement>;
  }
) => {
  return (
    <label ref={ref} className={twMerge(labelVariants({ variant }), className)} {...props} />
  );
};
